const IGNORED_AUTO_FILENAME_TOKENS = new Set(['image', 'file', 'screenshot']);
const SCREENSHOT_METADATA_TOKENS = new Set(['at', 'am', 'pm']);

const getBaseFilename = (name) => {
  if (!name) return '';
  return String(name)
    .split(/[/\\]/)
    .pop()
    .replace(/\.[^/.]+$/, '');
};

export const filterAutoFilenameTokens = (name) => {
  const base = getBaseFilename(name);
  if (!base) return '';

  const rawTokens = base
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter(Boolean);

  const tokens = rawTokens.filter((token) => !IGNORED_AUTO_FILENAME_TOKENS.has(token));

  const isScreenshotFilename = rawTokens[0] === 'screenshot';
  if (isScreenshotFilename && tokens.every((token) => /^\d+$/.test(token) || SCREENSHOT_METADATA_TOKENS.has(token))) return '';

  // Clipboard blobs are often named "image", "image 2", "file", etc.
  // If filtering leaves only a numeric suffix, don't auto-suggest anything.
  if (!tokens.length || tokens.every((token) => /^\d+$/.test(token))) return '';

  return tokens.join(' ');
};
